import { useIntl } from 'react-intl';

export const INSERTION_ORDERS_COLUMN_VISIBILITY_KEY = 'insertionOrdersList';

// Assumed (ticket does not define it): every column except name, leading and actions can be hidden.
export const INSERTION_ORDERS_HIDEABLE_COLUMN_IDS = ['media', 'status', 'duration', 'lastUpdate', 'budgetSpend'];

/** Labels of the hideable columns plus the name entry shown (always checked) in the column visibility menu. */
export function useInsertionOrdersColumnLabels(): Record<string, string> {
  const { formatMessage } = useIntl();

  return {
    budgetSpend: formatMessage({ defaultMessage: 'Budget Spent', id: 'insertionOrders.list.toolbar.budget' }),
    duration: formatMessage({ defaultMessage: 'Duration', id: 'insertionOrders.list.toolbar.duration' }),
    lastUpdate: formatMessage({ defaultMessage: 'Last Update', id: 'insertionOrders.list.toolbar.date' }),
    media: formatMessage({ defaultMessage: 'Media Channel', id: 'insertionOrders.list.toolbar.media' }),
    name: formatMessage({ defaultMessage: 'Insertion Order name', id: 'insertionOrders.list.columnVisibility.name' }),
    status: formatMessage({ defaultMessage: 'Status', id: 'insertionOrders.list.toolbar.status' })
  };
}
